export const excludedRecommendation = null;



// WEBPACK FOOTER //
// ./src/config/excludedRecommendation/ExcludedRecommendation.js